import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Shield, X, Check, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';

interface CookieSettings {
  essential: boolean;
  performance: boolean;
  functionality: boolean;
  analysis: boolean;
}

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setIsVisible(false);
  };

  const handleViewTerms = () => {
    setShowTermsModal(true);
  };

  return (
    <>
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-[100]"
          >
            <div className="bg-white rounded-3xl shadow-2xl border border-slate-100 p-6 md:p-8 space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-50 text-primary rounded-2xl flex items-center justify-center shrink-0">
                  <Shield size={24} />
                </div>
                <div className="space-y-2">
                  <h3 className="text-lg font-bold text-slate-900">Privacidade & Cookies</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    Utilizamos cookies para melhorar sua experiência, analisar o tráfego e personalizar conteúdos. Ao continuar navegando, você concorda com o uso de cookies.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <button
                  onClick={handleAccept}
                  className="bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-800 transition-all active:scale-[0.98]"
                >
                  Aceitar
                </button>
                <button
                  onClick={handleReject}
                  className="border border-slate-200 text-slate-700 py-3 rounded-xl font-bold hover:bg-slate-50 transition-all active:scale-[0.98]"
                >
                  Rejeitar
                </button>
              </div>
              <button
                onClick={handleViewTerms}
                className="w-full text-xs text-slate-500 underline hover:text-slate-700 pt-2 transition-colors"
              >
                Ver Política de Privacidade e Termos de Uso
              </button>
              
              <p className="text-[10px] text-slate-400 text-center">
                Saiba mais em nossa <Link to="/politica-de-privacidade" className="underline hover:text-primary">Política de Privacidade</Link>.
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default CookieConsent;
